import pages from "../../constants/menu";
import { find } from "../../layout/breadcrumbs/calculate";

export function pageIdentity(path, override = {}) {
  const routePage = find(path, pages) || pages[0];
  const acceptsOverride = Boolean(
    routePage.pageContext
    && override.context === routePage.pageContext
  );
  const overrideTitle = acceptsOverride ? String(override.title || "").trim() : "";
  const overrideBreadcrumb = acceptsOverride
    ? String(override.breadcrumb || "").trim()
    : "";

  return {
    routePage,
    title: overrideTitle || routePage.title,
    breadcrumb: overrideBreadcrumb || null,
  };
}

export default pageIdentity;
